/**
 * Labstep
 *
 * @module components/FilterPost/Active/Operator
 * @desc AND/OR operator for Filter Post Active
 */

import { Dropdown } from 'labstep-web/core/Dropdown';
import { PostFilterOperator } from 'labstep-web/services/postFilter/constants';
import type React from 'react';
import type { FilterPostActiveOperatorProps } from './types';

export const FilterPostActiveOperator: React.FC<
  FilterPostActiveOperatorProps
> = ({ type, setPostFilterNodeType }) => (
  <Dropdown icon={null} trigger={<b>{type.toUpperCase()}</b>}>
    {Object.values(PostFilterOperator).map((operator) => (
      <Dropdown.Item
        key={operator}
        onClick={(): void => setPostFilterNodeType(operator)}
      >
        {operator.toUpperCase()}
      </Dropdown.Item>
    ))}
  </Dropdown>
);
